// @flow strict
import * as React from 'react';
import Widget from 'views/logic/widgets/Widget';

const WidgetContext = React.createContext<?Widget>();

export default WidgetContext;
